<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Incluir Pedido',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading"
                            v-if="page.isNew && $check(user, ['creditorsrequests.create'])">Criar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading"
                            v-if="!page.isNew && $check(user, ['creditorsrequests.update'])">Salvar</v-btn>
                        <v-btn id="btnGoBack" type="button" color="primary" elevation="0" outlined
                            to="/pedidos-credores">Voltar</v-btn>
                    </div>
                </div>

            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Número do Pedido"
                                                v-model="dataset.data.request_number" required
                                                :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['creditorsrequests.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense id="registration" label="CPF/CNPJ"
                                                v-model="dataset.data.registration" required
                                                v-mask="dataset.data.registration.length < 15 ? this.$masks.cpf : this.$masks.cnpj"
                                                :rules="[$rules.required, validateCpfCnpj]" outlined
                                                hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['creditorsrequests.update'])))"></v-text-field>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field label="Origem (descrição)" dense v-model="dataset.data.origin"
                                                requiered :rules="[$rules.requried]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['creditorsrequests.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-currency-field label="Valor" dense v-model="dataset.data.value"
                                                :allowNegative=false hide-details="auto" requiered
                                                :rules="[$rules.requried]" outlined
                                                :disabled="!page.isNew && (!($check(user, ['creditorsrequests.update'])))">
                                            </v-currency-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>


<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

Vue.use(VueLodash)

export default {
    name: "upload-files",
    data() {
        return {
            $rules: {
                required: (v) => !!v || "Este campo é obrigatório",
            },
            user: null,
            page: {
                isNew: false,
                title: "",
                bntTitle: "",
            },
            dataset: {
                data: {
                    registration: "",
                },
                loading: false,
                errorData: [],
                creditor: []
            },
            dataForm: {
                validForm: true,
            },
        }
    },

    created() {
        this.setPage();
        this.loadData();
    },

    methods: {
        async loadData() {
            await this.load();
        },

        goBack() {
            this.$router.replace("/pedidos-credores");
        },

        setPage() {
            const routeId = this.$route.params.id;
            this.page.isNew = routeId && routeId.toLowerCase() === "novo";
            this.page.title = this.page.isNew ? 'Novo pedido' : 'Detalhes do pedido';
            this.page.bntTitle = this.page.isNew ? 'Criar' : 'Atualizar';
        },

        validateCpfCnpj(value) {
            const digits = value.replace(/\D/g, "");
            if (digits.length === 11 || digits.length === 14) {
                return true;
            }
            return "O CPF/CNPJ deve ter 11 ou 14 dígitos.";
        },


        buildPayload() {
            return {
                request_number: this.dataset.data.request_number,
                registration: this.dataset.data.registration.replace(/\D/g, ''),
                origin: this.dataset.data.origin,
                value: this.dataset.data.value,
            };
        },


        async load() {
            this.user = this.$root.user.data || this.$root.user;

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/creditors-requests/${this.$route.params.id}`);
                //console.log('result ', result)

                const data = result.data.data;

                this.dataset.data = data;
                //console.log('data ', this.dataset.data)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async add() {
            if (!this.$refs.form.validate()) return;


            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir este pedido?',
                title: 'Incluir Pedido',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            });

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/creditors-requests', payload);

                this.$dialog.notify.info("Pedido salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            if (this.page.isNew) return;



            if (!this.$refs.form.validate()) return;

            if (!this.$route.params.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o caso?',
                title: 'Atualizar caso',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/creditors-requests/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Caso atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },


    }

};
</script>

<style>
.example-row {
    display: flex;
    border-bottom: 1px solid #ccc;
}

.example-col {
    flex: 1;
    padding: 8px;
}

.example-col:first-child {
    flex: 2;
}
</style>